import React, { createContext, useContext } from "react";

import type { FacebookIdProviderProps } from "./types";

const FacebookIdContext = createContext<string>("");

export const FacebookIdProvider: React.FC<FacebookIdProviderProps> = ({
  children,
  facebookId,
}) => {
  return (
    <FacebookIdContext.Provider value={facebookId}>
      {children}
    </FacebookIdContext.Provider>
  );
};

export const useFacebookId = (): string => {
  return useContext(FacebookIdContext);
};
